import { useLayoutEffect, useRef } from "react";

/**
 * Captures the current focused element ({@link document.activeElement})
 * when {@link capture} is `true` and restores the element's focus when `false`.
 */
export function useFocusRestoration(capture: boolean) {
	// WeakRef is used to prevent the detached element issue (memory leak).
	const ref = useRef<WeakRef<HTMLElement | SVGElement>>();

	// useLayoutEffect is used over useEffect because the former is synchronous.
	useLayoutEffect(() => {
		if (capture) {
			const { activeElement } = document;
			if (
				activeElement instanceof HTMLElement ||
				activeElement instanceof SVGElement
			) {
				ref.current = new WeakRef(activeElement);
			}
		} else {
			const { current } = ref;
			if (current) {
				ref.current = undefined;
				const previousActive = current.deref();
				if (previousActive?.isConnected) {
					previousActive.focus();
				}
			}
		}
	}, [capture]);
}
